<template>
  <div class="h">
    <dashboard-nav ref="modal" />
    <div
      class="overflow-y-scroll px-4 md:px-8 lg:pt-24 pb-6 xl:px-24 xxl:max-w-screen-xxl xxl:m-auto 2xl:px-0"
    >
      <h5 v-if="profile.user" class="profile-name mt-5 lg:mt-10 text-xl lg:text-8 text-title">
        {{ timeOfDay() }}, {{ profile.user.firstName }}
      </h5>
      <div class="flex flex-col-reverse lg:flex-row mt-5 lg:mt-12 w-full">
        <div class="lg:min-w-110 bg-accent-2 rounded">
          <div class="pt-5 pb-4 px-4 lg:px-8 bg-accent-2 rounded mt-4 lg:mt-0">
            <span class="refer--header text-title block lg:text-6"
              >Earn up to N10,000 monthly by referring your friends to
              Loanspot</span
            >
            <span class="text-3 lg:text-3.5 text-sec-text mt-4 lg:mt-6 block"
              >You can share your referral link by copying and sending it or
              sharing to your social media.</span
            >
            <div class="mt-4 px-4 h-12 bg-white rounded flex items-center">
              <input
                v-if="profile.user"
                id="referral-code"
                type="text"
                :value="
                  'https://app.loanspot.africa/signup?referral=' +
                  profile.user.referralCode
                "
                class="bg-transparent w-full pr-5 text-3 text-primary focus:border-0 focus:outline-none"
                readonly
              />
              <span
                @click.prevent="copyReferral"
                class="-ml-4 lg:hidden cursor-pointer"
              >
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.25 3.5V1.25C3.25 1.05109 3.32902 0.860322 3.46967 0.71967C3.61032 0.579018 3.80109 0.5 4 0.5H13C13.1989 0.5 13.3897 0.579018 13.5303 0.71967C13.671 0.860322 13.75 1.05109 13.75 1.25V11.75C13.75 11.9489 13.671 12.1397 13.5303 12.2803C13.3897 12.421 13.1989 12.5 13 12.5H10.75V14.75C10.75 15.164 10.4125 15.5 9.99475 15.5H1.00525C0.906345 15.5006 0.808298 15.4816 0.716742 15.4442C0.625186 15.4068 0.541925 15.3517 0.471744 15.282C0.401563 15.2123 0.345845 15.1294 0.307791 15.0381C0.269737 14.9468 0.250097 14.8489 0.25 14.75L0.25225 4.25C0.25225 3.836 0.58975 3.5 1.0075 3.5H3.25ZM1.75225 5L1.75 14H9.25V5H1.75225ZM4.75 3.5H10.75V11H12.25V2H4.75V3.5Z"
                    fill="#1656C1"
                  />
                </svg>
              </span>
              <span
                @click.prevent="copyReferral"
                class="-ml-4 hidden lg:inline w-20 text-sm text-primary cursor-pointer copy-link"
                >Copy link</span
              >
            </div>
          </div>

          <div
            class="pt-5 pb-4 px-4 bg-accent-2 rounded mt-4 flex md:flex-col items-center justify-center"
          >
            <span class="text-xs xxs:text-sm text-sec-text">Share on</span>
            <div class="ml-6 md:ml-0 md:mt-6 flex">
              <a href="" class="">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="50" height="50" rx="4" fill="white" />
                  <path
                    d="M33.625 15.625H16.375C15.9602 15.625 15.625 15.9602 15.625 16.375V33.625C15.625 34.0398 15.9602 34.375 16.375 34.375H33.625C34.0398 34.375 34.375 34.0398 34.375 33.625V16.375C34.375 15.9602 34.0398 15.625 33.625 15.625ZM21.1867 31.6023H18.4047V22.6539H21.1867V31.6023ZM19.7969 21.4305C19.478 21.4305 19.1662 21.3359 18.901 21.1587C18.6358 20.9815 18.4292 20.7297 18.3071 20.435C18.1851 20.1404 18.1531 19.8162 18.2154 19.5034C18.2776 19.1906 18.4312 18.9033 18.6567 18.6778C18.8822 18.4522 19.1695 18.2987 19.4823 18.2365C19.7951 18.1742 20.1193 18.2062 20.414 18.3282C20.7086 18.4503 20.9604 18.6569 21.1376 18.9221C21.3148 19.1873 21.4094 19.499 21.4094 19.818C21.407 20.7086 20.6852 21.4305 19.7969 21.4305ZM31.6023 31.6023H28.8227V27.25C28.8227 26.2117 28.8039 24.8781 27.3766 24.8781C25.9305 24.8781 25.7078 26.0078 25.7078 27.175V31.6023H22.9305V22.6539H25.5977V23.8773H25.6352C26.0055 23.1742 26.9125 22.4312 28.2672 22.4312C31.0844 22.4312 31.6023 24.2852 31.6023 26.6945V31.6023Z"
                    fill="#1656C1"
                  />
                </svg>
              </a>
              <a href="" class="ml-4">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="50" height="50" rx="4" fill="white" />
                  <path
                    d="M34.7499 18.9602C34.0327 19.2695 33.2522 19.4922 32.4483 19.5789C33.283 19.0831 33.908 18.2997 34.2062 17.3758C33.4229 17.8417 32.5649 18.1684 31.6702 18.3414C31.2963 17.9416 30.844 17.6231 30.3415 17.4058C29.8391 17.1885 29.2973 17.0769 28.7499 17.0781C26.5351 17.0781 24.7538 18.8734 24.7538 21.0766C24.7538 21.3859 24.7913 21.6953 24.8522 21.993C21.5358 21.8195 18.578 20.2352 16.6116 17.8094C16.2533 18.4214 16.0656 19.1182 16.0679 19.8274C16.0679 21.2149 16.7733 22.4383 17.8491 23.1578C17.2151 23.1329 16.596 22.9586 16.0421 22.6492V22.6984C16.0421 24.6414 17.4155 26.2516 19.246 26.6219C18.9023 26.7112 18.5487 26.7568 18.1937 26.7578C17.9335 26.7578 17.6874 26.732 17.439 26.6969C17.9452 28.2813 19.4194 29.432 21.1749 29.4695C19.8015 30.5453 18.0812 31.1781 16.2132 31.1781C15.878 31.1781 15.5687 31.1664 15.2476 31.1289C17.0194 32.2656 19.1218 32.9219 21.3858 32.9219C28.7358 32.9219 32.7577 26.8328 32.7577 21.5477C32.7577 21.3742 32.7577 21.2008 32.746 21.0274C33.5241 20.4578 34.2062 19.7524 34.7499 18.9602Z"
                    fill="#1656C1"
                  />
                </svg>
              </a>
              <a href="" class="ml-4">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="50" height="50" rx="4" fill="white" />
                  <g clip-path="url(#clip0)">
                    <path
                      d="M18.6519 15C16.6289 15 15 16.6289 15 18.6519V31.3481C15 33.3711 16.6289 35 18.6519 35H25.5331V27.1813H23.4656V24.3663H25.5331V21.9613C25.5331 20.0718 26.7547 18.3369 29.5688 18.3369C30.7081 18.3369 31.5506 18.4463 31.5506 18.4463L31.4844 21.075C31.4844 21.075 30.6251 21.0669 29.6875 21.0669C28.6727 21.0669 28.51 21.5345 28.51 22.3107V24.3663H31.565L31.4319 27.1813H28.51V35H31.3481C33.3711 35 35 33.3711 35 31.3482V18.6519C35 16.6289 33.3711 15 31.3481 15H18.6519L18.6519 15Z"
                      fill="#1656C1"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(15 15)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div
          v-if="loanHistory.length === 0"
          class="pt-5 pb-4 px-4 lg:px-8 bg-accent-2 rounded w-full lg:ml-6"
        >
          <span class="no-loan--header text-title lg:text-6">Loans</span>
          <div class="mt-4 py-6 px-4 lg:py-8 bg-white rounded">
            <span
              class="no-loan--header text-title text-center block lg:text-6 xl:w-90 xl:mx-auto"
              >Get the best loan offers suited to your use case.</span
            >
            <button
              @click="showSearchModal"
              class="no-loan--btn mt-8 bg-primary rounded-lg text-white w-full h-14 xl:w-110 xl:mx-auto block"
            >
              Search for a loan now
            </button>
          </div>
        </div>

        <div
          v-if="loanHistory.length > 0"
          class="pt-5 pb-4 px-4 lg:px-8 bg-accent-2 rounded w-full lg:ml-6"
        >
          <div
            class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
          >
            <span class="no-loan--header text-title lg:text-6">Recent</span>
            <button
              @click="showSearchModal"
              class="no-loan--btn mt-4 text-3 bg-primary rounded-lg text-white w-36 h-10"
            >
              Apply for loan
            </button>
          </div>

          <div class="mt-4 p-4 bg-white rounded">
            <div v-for="(loan, i) in loanHistory" :key="i" class="">
              <!-- :class="loan[1] ? 'pt-4' : ''" -->
              <span class="block text-2.5 py-2 text-sec-text">{{
                dateFormat(loan.createdAt)
              }}</span>
              <div
                v-for="(lender, j) in loan.lenders"
                :key="j"
                class="grid gap-5 justify-between grid-cols-2 md:grid-cols-3 border-t pb-2 border-input"
              >
                <div class="pt-2 w-full">
                  <p class="text-2.5 text-sec-text">Name</p>
                  <p class="loan-detail text-sm text-title">
                    {{ lender.name }}
                  </p>
                </div>
                <div class="pt-2 w-full ml-3 md:ml-10">
                  <p class="text-2.5 text-sec-text">Type of Loan</p>
                  <p class="loan-detail text-sm text-title">
                    {{ loan.loanType.name }}
                  </p>
                </div>
                <div class="pt-2 w-full">
                  <p class="text-2.5 text-sec-text">Amount Requested</p>
                  <p class="loan-detail text-sm text-title">
                    {{ formatLoanAmount(loan.amount) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      v-if="getStarted"
      @click.self="getStarted = false"
      class="fixed bg-search-bg top-0 left-0 right-0 h-screen w-full flex justify-center overflow-y-scroll px-4"
    >
      <div
        class="px-6 pt-6 pb-12 mt-28 bg-white rounded-lg border border-border h-min max-w-md"
      >
        
        <div class="get-started-modal rounded-lg p-5 text-white text-5 title" id="get-started-modal">
          Hi {{profile.user.firstName}},
          <span class="text-sm mt-1 block">Welcome to Loanspot</span>
        </div>
        <h5 class="mt-5  title">Get Started</h5>
        <p class="text-sm text-ssec-text mt-2">
          Increase your chances of getting your loan application approved by updating your information now. 
        </p>
        <router-link to="/settings">
          <div class="mt-12 rounded text-white flex items-center justify-center bg-primary h-14 w-full md:w-50 md:mx-auto title">Update Information</div>
        </router-link>
      </div>
    </div>   -->
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { DASHBOARD_ROUTES } from "../constants";
import DashboardNav from "../components/partials/dashboard-nav";
import { ApiInstance as api } from "../utils";
import { BASE_API } from '../constants';
import mixpanel from 'mixpanel-browser';

export default {
  name: "Home",
  components: {
    DashboardNav,
  },
  beforeCreate() {
    if (!localStorage.getItem('auth-token')) return this.$router.replace('/login');
    this.$store.dispatch('userProfile');
  },
  async mounted() {
    // Kindly remove
    // if(this.profile?.phoneNumberVerified === false) return this.$router.replace('/verification/phone');
    // if(this.profile?.updatedProfile === false) return this.$router.replace('/setup/complete');
    if(this.profile?.user?.email) {
      if (this.profile?.user.referralCode === null) {
        await api.get('/referral');
      }
      mixpanel.identify(this.profile.user.email);
      mixpanel.people.set({
        '$name': `${this.profile.user.firstName} ${this.profile.user.lastName}`,
        '$email': this.profile?.user.email,
        ...this.profile.user
      });
    }
    if(localStorage.getItem('initialApply')) {
      const applied = JSON.parse(localStorage.getItem('applied'));
      this.fromSearch.amount = applied.amount;
      this.fromSearch.income = applied.income;
      this.fromSearch.loanType = applied.loanType;
      this.fromSearch.loanPurpose = applied.loanPurpose;
      this.fromSearch.existingLoan = applied.existingLoan;

      this.$router.push(`/search?${new URLSearchParams(this.fromSearch).toString()}`)
    }
    
    const res = await api.get('/loans');
    
    const recentItems = res.data?.data.items.slice(0, 2) || [];
    this.loanHistory = recentItems;
    
    this.fetchLoanTypes();
    this.fetchLoanPurposes();
  },
  computed: {
    ...mapState({
      profile: (state) => state.profile,
    }),
    amount() {
      return this.search.amount;
    },
    income() {
      return this.search.income;
    },
  },
  watch: {
    amount(event) {
      if (event.key >= 37 && event.key <= 40) return;
      this.search.amount = this.search.amount
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    income(event) {
      if (event.key >= 37 && event.key <= 40) return;
      this.search.income = this.search.income
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      getStarted: true,
      search: {
        amount: "",
        income: "",
      },
      slideIn: "hidden",
      hideHamburger: "",
      logout: false,
      recentLoans: false,
      // showSearchModal: false,
      loanHistory: [],
      dashboard: {
        overview: DASHBOARD_ROUTES.OVERVIEW,
        history: DASHBOARD_ROUTES.HISTORY,
        settings: DASHBOARD_ROUTES.SETTINHS,
        help: DASHBOARD_ROUTES.HELP,
      },
      dropdownOptions: {},
      loanTypes: [],
      loanTypeBusiness: false,
      loanTypeIndividual: false,
      existingLoanYes: false,
      existingLoanNo: false,
      dayGreetings: [
        [17, 'Good evening'],
        [12, 'Good afternoon'],
        [0, 'Good morning'],
      ],
      fromSearch: {
        page: 1,
        limit: 10,
        amount: '',
        loanCurrency: 'NGN',
        income: '',
        loanType: '',
        loanPurpose: '',
        existingLoan: ''
      }
    };
  },
  methods: {
    formatLoanAmount(number) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(number);
    },
    showSearchModal() {
      this.$refs.modal.searchLoanForm = true
    },
    copyReferral() {
      let link = document.getElementById("referral-code");
      link.select();
      link.setSelectionRange(0, 99999);
      document.execCommand("copy");
      this.$notie.alert({
        type: "success",
        text: "Link copied to clipboard.",
        time: 3,
      });
    },
    async fetchLoanPurposes() {
      try {
        const response = await (
          await fetch(BASE_API + "/loan-purposes")
        ).json();
        this.dropdownOptions.business = response.data.filter(
          (p) => p.loanType.slug === "business"
        );
        this.dropdownOptions.individual = response.data.filter(
          (p) => p.loanType.slug === "individual"
        );
      } catch (error) {
        // console.log(error);
      }
    },
    async fetchLoanTypes() {
      try {
        const response = await (await fetch(BASE_API + "/loan-types")).json();
        this.loanTypes = response.data;
      } catch (error) {
        // console.log(error);
      }
    },
    setLoanBusiness() {
      this.loanTypeBusiness = true;
      this.loanTypeIndividual = false;
    },
    setLoanIndividual() {
      this.loanTypeIndividual = true;
      this.loanTypeBusiness = false;
    },
    setExistingLoanYes() {
      this.existingLoanYes = true;
      this.existingLoanNo = false;
    },
    setExistingLoanNo() {
      this.existingLoanNo = true;
      this.existingLoanYes = false;
    },
    submitSearch(e) {
      if (this.search.amount === "") {
        return this.$notie.alert({
          text: `Please input an amount to borrow`,
          type: "error",
          time: 3,
          position: "top",
        });
      }
      if (this.search.income === "") {
        return this.$notie.alert({
          text: `Please input your net monthly income`,
          type: "error",
          time: 3,
          position: "top",
        });
      }

      const loanTypeInputs = document.getElementsByName("loan-type");
      let loanTypeValue;

      for (let i = 0; i < loanTypeInputs.length; i++) {
        if (loanTypeInputs[i].checked) {
          loanTypeValue = loanTypeInputs[i].value;
          return loanTypeValue;
        }
      }

      const params = {
        page: 1,
        limit: 10,
      };

      for (const [key, value] of new FormData(e.target).entries()) {
        console.log(key, value);
        if (["amount", "income"].includes(key)) {
          params[key] = value.replace(/,/gi, "");
        } else if (key === "loanType") {
          const type = this.loanTypes.find((t) => t.slug === value);
          if (type) {
            params[key] = type.id;
          }
        } else params[key] = value;
      }

      const query = new URLSearchParams(params).toString();
      const url = "/search?" + query;
      // console.log(params);
      // console.log(url);
      window.open(url, "_self");
    },
    dateFormat(date) {
      const created = new Date(date).toDateString();
      const formatted = created.split(' ').slice(1);
      return formatted.join(" ");
    },
    timeOfDay() {
      const hour = new Date().getHours();
      for(let i = 0; i < this.dayGreetings.length; i++) {
        if(hour >= this.dayGreetings[i][0]) {
          return this.dayGreetings[i][1]
        }
      }
    },
  },
  head: {
    title: function () {
      return {
        inner: "Loanspot",
        complement: "Dashboard",
      };
    },
    meta: [
      { name: "description", content: "Loanspot dashboard" },
      { name: "application-name", content: "Loanspot" },
    ],
  },
};
</script>

<style lang="scss" scoped>
.get-started-modal {
  width: 100%;
  height: 144px;
  background: url('../../public/welcom-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.profile-name,
.no-loan--header,
.no-loan--btn,
.loan-detail,
.refer--header,
.copy-link,
.title {
  font-family: SohneKraftig, sans-serif;
}
.input-label {
  font-family: SohneKraftig, sans-serif;
  font-size: 0.75rem;
  color: #575a65;
}

.input-wrap {
  height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #f9fafc;
  border-radius: 8px;

  .input {
    width: 100%;
    height: inherit;
    border-radius: 8px;
    border-top: 1px solid #e5e9f2;
    border-bottom: 1px solid #e5e9f2;
    border-left: 1px solid #e5e9f2;
    border-right: none;
    color: #323643;
    padding: 0 16px;
    font-family: SohneKraftig, sans-serif;
    font-size: 0.875rem;
    letter-spacing: 1px;
    background-color: transparent;

    &:focus,
    &:active {
      outline: none;
      border: 1px solid #1656c1;
    }
  }

  .input--currency-wrap {
    height: 48px;
    width: 72px;
    padding: 0 8px 0 8px;
    box-sizing: border-box;
    background-color: #1656c1;
    border: 1px solid #1656c1;
    border-radius: 0 8px 8px 0;
    margin-left: -72px;

    .input--currency {
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      height: 100%;
      width: 100%;
      background-color: #1656c1;
      font-size: 0.875rem;
      border: none;
      color: #ffffff;
      padding: 0;
      &:focus,
      &:active {
        outline: none;
      }
    }
  }
}

.income-wrap,
.loan-type-wrap,
.purpose-wrap,
.existng-loan-wrap {
  margin-top: 16px;
}

.loan-type-radio,
.existing-loan-radio {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  .input-wrap {
    border: 1px solid #e5e9f2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    color: #575a65;
    cursor: pointer;

    &:hover {
      border: 1px solid #1656c1;
      color: #1656c1;
      font-family: SohneKraftig, sans-serif;
    }
  }

  .input {
    display: none;
  }
}

.radio-type--selected {
  border: 1px solid #1656c1 !important;
  color: #1656c1 !important;
  font-family: SohneKraftig, sans-serif;
}

.input-wrap--purpose {
  padding-right: 12px;
  border: 1px solid #e5e9f2;
  cursor: pointer;
  .input--purpose {
    width: 100%;
    height: inherit;
    border-radius: 8px;
    background-color: transparent;
    padding: 0 16px;
    border: none;
    color: #575a65;

    &:focus,
    &:active {
      outline: none;
      // border: 1px solid $primary-color;
    }
  }
  select {
    color: #575a65;
    font-size: 0.875rem;
  }
}

.form-btn {
  font-family: SohneKraftig, sans-serif;
  color: #ffffff;
  background-color: #1656c1;
  border-radius: 8px;
  border: none;
  outline: none;
  width: 100%;
  height: 56px;
  margin-top: 32px;
  cursor: pointer;

  &:focus,
  &:active {
    outline: none;
  }
}
</style>
